var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',[_c('div',{staticClass:"content"},[((_vm.$account && _vm.$account.partner) || (_vm.$account && _vm.$account.company))?_c('b-card',{domProps:{"innerHTML":_vm._s(_vm.$t('partners.builder_iframe_text'))}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }